module.exports = __webpack_public_path__ + "assets/img/00165.e4aad698.png";